import classNames from 'classnames'

import Icon from 'components/Icon'

import style from './index.module.scss'

const Button = ({
  type = 'button',
  placeholder,
  children,
  onChange = () => {},
  classes = ['primary', 'lg'],
  isDisabled = false,
  isLoading = false,
  isActive = false,
  ...rest
}) => {
  return (
    <button
      type={type}
      className={
        classNames(
          style.block,
          {
            [style.active]: isActive,
            [style.disabled]: isDisabled,
            [style.loading]: isLoading,
          },
          classes && classes.map(el => style[el] || el),
        )
      }
      disabled={isDisabled}
      onClick={onChange}
      aria-label={placeholder || 'Button'}
      {...rest}
    >
      <span className={style.placeholder}>{children || placeholder}</span>
      {
        isLoading &&
        <span className={style.spinner}>
          <Icon
            size={'lg'}
            name={'icon-games-spinner'}
          />
        </span>
      }
    </button>
  )
}

export default Button
